export default __webpack_public_path__ + "static/media/img (1).9ef96972.jpg";